import { render, staticRenderFns } from "./MyPerf.vue?vue&type=template&id=246e41bc&"
import script from "./MyPerf.vue?vue&type=script&lang=js&"
export * from "./MyPerf.vue?vue&type=script&lang=js&"
import style0 from "./MyPerf.vue?vue&type=style&index=0&id=246e41bc&prod&lang=scss&"
import style1 from "./MyPerf.vue?vue&type=style&index=1&id=246e41bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports